import React from 'react';
import { LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { BRAND, MAIN_MOCKUP, MOCKUP_ALT, pricing } from '../data/sushiContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-champagne/25 bg-black" aria-labelledby="final-title" data-id="element-113" data-mp="2o07ba18k9v9t">
      <div className="mx-auto grid max-w-4xl items-center gap-8 px-5 py-12 sm:grid-cols-2 sm:gap-10 sm:py-16" data-id="element-114" data-mp="1qdi1h57maede">
        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm sm:max-w-none" width={1536} height={1024} data-id="element-115" data-mp="1vbrw9epfjcyh" />

        <div className="text-center sm:text-left" data-id="element-116" data-mp="251v0yc5wyfcn">
          <CountdownTimer label="El precio cierra en" className="sm:text-left [&>div]:justify-center sm:[&>div]:justify-start" data-id="element-117" data-mp="17lp6x6cwgl3k" />

          <h2 id="final-title" className="mt-7 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-118" data-mp="1cj7gmyyqr4cm">
            {BRAND}
          </h2>
          <p className="mt-2 text-[12px] uppercase tracking-[0.14em] text-body" data-id="element-119" data-mp="27kuwqt5wuci0">
            90 páginas + 3 bonos · 7 formatos sin enrollar
          </p>

          <p className="mt-5 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-120" data-mp="1xrxcoil9sfha">
            Precio regular: {pricing.regularPrice}
          </p>
          <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-121" data-mp="1os0r4pu6fwqg">
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-122" data-mp="1jtftmy6b7r5p">
              USD
            </span>
          </p>

          <div className="mt-6 flex justify-center sm:justify-start" data-id="element-123" data-mp="3e65nxh0lb2dm">
            <CtaButton target="checkout" size="md" label="Quiero acceso AHORA →" data-id="element-124" data-mp="398dlht2bjxv6" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:justify-start" data-id="element-125" data-mp="17j7znt5s887l">
            <LockIcon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-126" data-mp="1cazgvd31t1l2" />
            Pago 100% seguro
          </p>
          <TrustStrip variant="full" className="mt-3 sm:justify-start" data-id="element-127" data-mp="12jln7lxs2vzu" />
        </div>
      </div>
    </section>;
}